import React from 'react'

import { Map, Marker, APILoader } from '@uiw/react-baidu-map'

export default function MapSection() {
  return (
    <div style={{ width: '100%', height: '100%' }}>
      <APILoader akay="jVjIjQe4vf3424DyfeblWYxmz4lnI8Q5">
        <Map zoom={16} center={{ lng: 118.652417, lat: 32.043142 }}>
          <Marker position={{ lng: 118.652417, lat: 32.043142 }} />
        </Map>
      </APILoader>
    </div>
  )
}
